








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { popover } from '@libs-uuif/shared/popover-dir';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { State } from 'vuex-class';
import { RootStoreState } from '@/store';
import ServiceStatusDialog from './serviceStatusDialog.vue';
import ActivateServiceDialog from './activateServiceDialog.vue';
import ManageSharedLicense from './manageSharedLicenseDialog.vue';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { currentUserKey } from '@/shared/msw-constants';
import { envCongif } from '@/shared/env.config';
import ManualLicensesDialog from './manual-licenses-dialog.vue';
import AddKeysetDialog from './add-keyset-dialog.vue';
import ApiServiceWrapper from '@/shared/api-request.service';
import { InfoState } from '@/core/core.store';
import {
  SwTreeList,
  SwTreeListItem,
  ItemExpandRequestData,
} from '@libs-uuif/shared/sw-tree-list';
import { SwExpandableTextfield, SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import SysLogAnaltyics from './todoComponents/sysLogAnaltyicsDialog.vue';
import { CreateElement, VNode } from 'vue';
import {
  ConfirmOptions,
  confirmService,
} from '@sonicwall/unified-ui-framework/src/shared/confirm-service';
import { Base64 } from 'js-base64';
import { localStorageKeeperService } from '@/shared/auth-service';
import SecureUpdate from '../secure-update.vue';
import MsspMonthlyManagedDialog from './conifrmMSSPMonthlyManagedDialog.vue';
import FreeTrialUpdateModal from './free-trial-update-modal.vue';

@Component({
  components: {
    ...UUIFComponent,
    ServiceStatusDialog,
    ActivateServiceDialog,
    ManageSharedLicense,
    AddKeysetDialog,
    ManualLicensesDialog,
    SwTreeList,
    SwTreeListItem,
    SwExpandableTextfield,
    SwTextfield,
    SwScrollView,
    SysLogAnaltyics,
    SecureUpdate,
    MsspMonthlyManagedDialog,
    FreeTrialUpdateModal,
  },
  directives: {
    popover,
    tooltip,
  },
})
export default class MswProductDetailServiceList extends SwExtendedVue {
  @State((state: RootStoreState) => state.MswProductsStoreModule.productDetails)
  productDetails: any;
  @State((state: RootStoreState) => state.MswProductsStoreModule.selectedSerialNumer)
  serialNumber: string;
  @Prop()
  isReadOnly: boolean;
  @Prop()
  activeTenantId: string;
  serviceList: any[] = [];
  isSignatureAvailable: boolean = false;
  licenseList: any = {};
  sysLogInputs: any = {};
  expandedTreeListItems: any[] = [];
  selectedTreeListItems: any[] = [];
  serviceListSearchText: string = '';
  manualLicenses: string = '';
  sha256checksum: string = '';
  showAddManualKeysetDialog: boolean = false;
  iconConfig2 = {
    name: 'search',
    color: '#FF791A',
  };
  filteredServiceList: any[] = [];
  expandedServiceList: any[] = [];
  // showProductActivateDialog: boolean = false;
  showAddKeysetDialog: boolean = false;
  showServiceStatusDialog: boolean = false;
  showSysLogAnaltyicsDialog: boolean = false;
  showCASDialog: boolean = false;
  showActivateServiceDialog: boolean = false;
  showManageSharedLicenseDialog: boolean = false;
  selectedService: any = {};
  dcOptions: any = [];
  rootServiceId: string = '';
  activationKey: string = '';
  aptTerms: string;
  serviceApiResponse: any;
  isFreeTrial: boolean = false;
  addKeyResponse: any;
  expandAccordion: boolean = false;
  // for the license management
  isExpandSearchFilter: boolean = false;
  selectedServiceOption: string = 'all';
  actKey: string = '';
  showActivateButton: boolean = false;
  readonly: boolean = false;
  messageAccept: string = '';
  expand: boolean = true;
  type: string = '';
  iconColor: string = '#ff791a';
  loadingText = '';
  totalfifthColWidth: number = 0;
  isShowDirectLSG: boolean = true;
  sigIDList: any;
  isoverRide: string = 'NO';
  isConfirmFwReboot: boolean = false;
  showSecureUpdateModal: boolean = false;
  secUpdatePage: string = 'REPLACEMENTTYPE:SMA100TRADEUP';
  activateServiceData: any = {};
  isTradeInRequiredForServiceActivation: boolean = false;
  acceptedMpssDowngrade: boolean = false;
  showMonthlyConvertPopup = false;
  convertTomonthly = 'yes';
  showMSSPMonthlyManagedDialog = false;
  isSecaas: boolean = false;
  openFreeTrialUpdateModal: boolean = false;
  freetrialUpgradeConfirmation: any;
  // fileDownloadGatewayAPI: string;
  // csaFirmwareUpdateFileType: string;
  // csaFirmwareDownloadLinkText: string;
  // isCsaFirmwareS3FileAvailable: boolean;
  // isCsaFirmwareS3FileAvailableIgnore: boolean;
  headerConfig: any = {
    header2: {
      width: 0,
    },
    header3: {
      width: 0,
    },
    header4: {
      width: 0,
    },
    header5: {
      width: 0,
    },
    header6: {
      width: 0,
    },
  };
  columnWidthConfigInitial: any = {
    column0: {
      name: 'serviceName',
      width: 0,
      widthPercentage: 0,
      type: 'service name',
      default: true,
    },
    column1: {
      name: 'status',
      width: 88.1,
      widthPercentage: 34.8,
      type: 'expiry',
      default: true,
    },
    column2: {
      name: 'count',
      width: 60,
      widthPercentage: 23.7,
      type: 'expiry',
      default: true,
    },
    column3: {
      name: 'expiry date',
      width: 105,
      widthPercentage: 41.48,
      type: 'expiry',
      default: true,
    },
    column4: {
      name: 'info icon',
      width: 50,
      type: 'actions',
      default: false,
    },
    column5: {
      name: 'csc icon',
      width: 27,
      type: 'actions',
      default: false,
    },
    column6: {
      name: 'sharing icon',
      width: 70,
      type: 'actions',
      default: false,
    },
    column7: {
      name: 'activate',
      width: 75,
      type: 'actions',
      default: true,
    },
    column8: {
      name: 'buy',
      width: 50,
      type: 'actions',
      default: true,
    },
    column9: {
      name: 'free trail',
      width: 80,
      type: 'actions',
      default: true,
    },
    EXPIRATION_DETAIL_TOTALWIDTH: 253.1,
    ACTION_COLUMN_TOTALWIDTH: 205,
    COUNT_COLUMN_SINGLE_CHARACTER_WIDTH: 10,
    COLUMN_PADDING_WIDTH: 10,
    MAXCOUNT_TEXT_WIDTH: 40,
    EXPIRING_SOON_ALERT_WIDTH: 15,
    TOTAL_COL_WIDTH_EXCEPT_SERVICENAME: 0,
  };
  columnWidthConfigModified: any = {};
  created() {
    this.filteredServiceList = [];
    this.expandedServiceList = [];
    this.getServiceList();
  }
  mounted() {
    this.readonly = this.isReadOnly ? this.isReadOnly : false;
    this.type = this.selectedServiceOption;
    if (this.expandedServiceList) {
      this.expandedServiceList.map((serviceType: any) => {
        serviceType.expanded = this.expand;
      });
    }
  }
  @Watch('isReadOnly')
  onChangeReadOnlyMode() {
    this.readonly = this.isReadOnly ? this.isReadOnly : false;
  }
  get customizedHtmlTooltip(): TooltipDirValues {
    // @ts-ignore
    return (message: any) => {
      return {
        compact: true,
        content: (h: CreateElement): VNode => {
          console.warn(h, message);
          return h('p', {
            domProps: {
              innerHTML: message,
            },
          }) as VNode;
        },
      };
    };
  }

  get fileDownloadGatewayAPI() {
    return this.productDetails.FileDownloadGatewayAPI;
  }

  get csaSmashUpdateFileType() {
    return this.productDetails.CsaSmashUpdateFileType;
  }
  get csaSmashUpdateDownloadLink() {
    return this.productDetails.CsaSmashUpdateDownloadLinkText;
  }
  get isCsaSmashUpdateS3FileAvailable() {
    return this.productDetails.isCsaSmashUpdateS3FileAvailable === 'YES';
  }
  get isCsaSmashUpdateS3FileAvailableIgnore() {
    return this.productDetails.isCsaSmashUpdateS3FileAvailableIgnore === '';
  }

  get csaFirmwareUpdateFileType() {
    return this.productDetails.CsaFirmwareUpdateFileType;
  }
  get csaFirmwareDownloadLinkText() {
    return this.productDetails.CsaFirmwareDownloadLinkText;
  }
  get isCsaFirmwareS3FileAvailable() {
    return this.productDetails.isCsaFirmwareS3FileAvailable === 'YES';
  }
  get isCsaFirmwareS3FileAvailableIgnore() {
    return this.productDetails.isCsaFirmwareS3FileAvailableIgnore === '';
  }
  get getToken() {
    const currentUser = localStorage.getItem(currentUserKey);
    return currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
  }
  get getInfoTooltip(): TooltipDirValues {
    const content = String(this.$t('products.keySetInfo'));
    return {
      content,
      placement: 'right',
      compact: true,
    };
  }
  get productDetailSerialNumber() {
    return this.productDetails.serialNumber;
  }
  get getIsoverRide() {
    return this.isoverRide;
  }

  onCancel() {
    this.showMonthlyConvertPopup = false;
  }

  onProceed() {
    if (this.convertTomonthly === 'yes') {
      this.showMSSPMonthlyManagedDialog = true;
      this.onCancel();
    } else {
      this.onCancel();
    }
  }

  closeMSSPMonthlyManaged(val: any) {
    this.showMSSPMonthlyManagedDialog = false;
    if (val === true) {
      this.$emit('detailsUpdated');
      this.$emit('updateProductDetails');
    }
  }

  handleSecureUpdateData(serialNumber: string) {
    // SMA100 to CSE Promotion
    if (
      this.isTradeInRequiredForServiceActivation &&
      Object.keys(this.activateServiceData)?.length > 0
    ) {
      const { activationKey = '', rootServiceID = 0 } =
        this.activateServiceData?.content || {};
      this.showActivateButton = true;
      this.actKey = activationKey;
      this.activate(...[rootServiceID, serialNumber]);
      return;
    }
    this.activate(...[, serialNumber]);
  }

  handleLink(firmwareOrSignature: string) {
    let env;
    switch (envCongif.env) {
      case 'DEV': {
        env = 'DEV';
        break;
      }
      case 'QA': {
        env = 'QA';
        break;
      }
      case 'SIMULATION': {
        env = 'SIM';
        break;
      }
      case 'PROD': {
        env = 'PROD';
        break;
      }
    }
    const currentUser = localStorage.getItem(currentUserKey);
    const token = currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
    if (firmwareOrSignature === 'firmware') {
      // tslint:disable-next-line
      window.open(
        `${this.fileDownloadGatewayAPI}token=${token}&serialnumber=${this.productDetails.serialNumber}&env=${env}&filetype=CSAFIRMWAREUPDATE`,
        '_blank',
      );
    } else {
      // tslint:disable-next-line
      window.open(
        `${this.fileDownloadGatewayAPI}token=${token}&serialnumber=${this.productDetails.serialNumber}&env=${env}&filetype=${this.csaSmashUpdateFileType}`,
        '_blank',
      );
    }
  }
  @Watch('serviceList')
  serviceListChange() {
    this.filteredServiceList = [...this.serviceList];
    this.expandedServiceList = [...this.serviceList];
    this.filterServices();
    if (this.$route.query.action && this.isShowDirectLSG) {
      if (this.$route.query.action.toString().toLowerCase() === 'managelsg') {
        if (this.productDetails.serialNumber === this.$route.query.serialNumber.toString()) {
          const accessLSG: { service: any; isEnable: boolean } = {
            service: {},
            isEnable: false,
          };
          this.serviceList.map((serviceType: any) => {
            serviceType.serviceList.forEach((service: any) => {
              if (service.primaryserialnumber !== '' && service.isShowActionOnTenantLink) {
                accessLSG.isEnable = true;
                accessLSG.service = service;
              }
            });
          });
          if (accessLSG.isEnable) {
            this.$store.commit('MswProductsStoreModule/mutate', {
              property: 'selectedSerialNumer',
              with: accessLSG.service.primaryserialnumber,
            });
            this.getServiceList();
            setTimeout(() => { this.showManageSharedLicense(accessLSG.service.serviceId); }, 1000);
            this.isShowDirectLSG = false;
          } else {
            this.showManageSharedLicense(this.productDetails.lsgServiceId);
            this.isShowDirectLSG = false;
          }
        }
      }
    }
  }
  @Watch('serviceListSearchText')
  filterServices() {
    this.filteredServiceList = [];
    this.expandedServiceList.map((serviceType: any) => {
      const services = this.filteredList(serviceType, this.selectedServiceOption);
      if (services.length > 0) {
        this.filteredServiceList.push({
          serviceTypeName: serviceType.serviceTypeName,
          serviceList: services,
          expanded: serviceType.expanded,
        });
      }
    });
    this.manageScroll();
  }
  @Watch('selectedServiceOption')
  selectedServiceOptionChanged() {
    this.type = this.selectedServiceOption;
  }
  addKeySetDialogToggle() {
    const request = `product/Get-LicenseKeySet-Versions?serialNumber=${this.productDetails.serialNumber}&productId=${this.productDetails.pID}&languageCode=en`;
    this.$store.dispatch('getLicenseKeySetVersions', request).then((res: any) => {
      if (res.operationStatus === 'OK') {
        this.$store.commit('stopLoading');
        this.addKeyResponse = res;
        this.showAddKeysetDialog = true;
      } else {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
        this.$store.commit('enqueueMessage', message);
      }
    });
  }
  getServiceAction(service: any) {
    if (service.serviceStatus === 'ACTIVATED') {
      if (service.expirydate === '') {
        return this.$t('products.upgrade').toString();
      }
      return this.$t('home.renew').toString();
    }
    return this.$t('products.activate').toString();
  }
  get isShowManualUpgrades() {
    return (
      this.productDetails.keyset === '1' ||
      this.isSignatureAvailable ||
      this.productDetails.isGeoIPApplicable
    );
  }
  get servicesOptions() {
    let servicesOptions: any[] = [];
    servicesOptions = [
      { id: 'all', label: this.$t('products.alllicenses').toString(), value: 'all' },
      { id: 'active', label: this.$t('products.prodactivated').toString(), value: 'active' },
      {
        id: 'in-active',
        label: this.$t('products.prodnotactivated').toString(),
        value: 'in-active',
      },
    ];
    return servicesOptions;
  }
  showCatalog(serviceId: string) {
    const encodedFriendlyName = this.encodedString(this.productDetails.friendlyName);
    const redirectUrl = `ui/catalog?serviceId=${serviceId}&serialNumber=${this.productDetails.serialNumber}&friendlyName=${encodedFriendlyName}`;
    const isVueMode = localStorageKeeperService.retrieve('buynowMode') || 'ANGULAR';
    if (isVueMode === 'VUE') {
      this.$router
        .push({
          path: `/m/feature/catalog?serviceId=${serviceId}&serialNumber=${this.productDetails.serialNumber}&friendlyName=${encodedFriendlyName}`,
        })
        .then(() => {
          if (!window.location.href.includes('localhost')) {
            window.parent.postMessage(
              {
                redirectUrl: `/m/feature/catalog?serviceId=${serviceId}&serialNumber=${this.productDetails.serialNumber}&friendlyName=${encodedFriendlyName}`,
              },
              '*',
            );
          }
        })
        .catch((e: any) => {
          console.error(e);
        });
    } else if (
      (window as { [key: string]: any }).top.location.href ===
      (window as { [key: string]: any }).location.href
    ) {
      this.$router.push({
        path: `/m/feature/catalog?serviceId=${serviceId}&serialNumber=${this.productDetails.serialNumber}&friendlyName=${encodedFriendlyName}`,
      });
    } else {
      this.$store.dispatch('navigateTo', redirectUrl);
    }
  }
  encodedString(friendlyName: string) {
    return Base64.encode(friendlyName) || '';
  }
  setRootServiceId(service: any) {
    this.rootServiceId = service.serviceId;
    this.selectedService = service;
    this.activateFreeTrial();
  }
  activateFreeTrial(req?: any, messageAccept: any = '') {
    this.isFreeTrial = true;
    const request = {
      messageAccept,
      rootServiceID: this.rootServiceId,
      username: this.$store.getters.getUserId,
      serialNumber: this.productDetails.serialNumber,
      activationKey: '',
      cscDataCenter: '',
      actionType: '',
      isFreeTrial: this.isFreeTrial.toString(),
      autoSendERDomains: '',
      dataCenterLocationID: '',
      adminEmail: '',
      companyName: '',
      casappid: '',
      ...req,
      isoverRide: this.isoverRide || 'NO',
    };
    if (
      request.rootServiceID === 6520 ||
      request.rootServiceID === 6560 ||
      request.rootServiceID === 6730 ||
      request.rootServiceID === 6745 ||
      request.rootServiceID === 6755
    ) {
      request.sbxDataCenter = '';
    }
    this.$store
      .dispatch('MswProductsStoreModule/activateService', request)
      .then((res: any) => {
        this.validateActivation(res);
      });
  }
  showActivation(service: any) {
    this.selectedService = service;
    this.showActivateServiceDialog = true;
  }
  showServiceStatus(service: any) {
    this.selectedService = service;
    this.showServiceStatusDialog = true;
  }
  activatePrimary(service: any) {
    if (service.primaryActionText !== '' && service.primaryserialnumber !== '') {
      this.$store.commit('MswProductsStoreModule/mutate', {
        property: 'selectedSerialNumer',
        with: service.primaryserialnumber,
      });
      this.getServiceList();
      if (service.serviceFamily === 'SENTINELONEADVANCED' ||
          service.serviceFamily === 'SENTINELONE' ||
          service.serviceFamily === 'SENTINELONEPREMIER' ||
          service.serviceFamily === 'CCMDR') {
        setTimeout(() => { this.showManageSharedLicense(service.serviceId); }, 1000);
      } else {
        this.showActivation(service);
      }
    }
  }
  validateActivation(res: any) {
    this.$store.commit('stopLoading');
    switch (res?.msgCode) {
      case 'MSWAPP:ACTSUCCESS':
      case 'FREETRIALOFFER:ACTIVATED':
      case 'GEN:SVCACTIVATION_INPROGRESS':
        if (this.isoverRide === 'YES') this.isoverRide = 'NO';
        this.messageAccept = '';
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res.msgDesc });
        this.getServiceList();
        this.$emit('needProductsUpdate');
        break;
      case 'MSWAPP:ACTFAILURE':
      case 'MSWAPP:LMREGISTRATIONREQUIRED':
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
        break;
      case 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT':
        this.secondaryserialnumbertransfer(res);
        break;
      case 'MSWAPP:FWINCCLSG':
        this.showConfirmationDialogForStartTrial(res);
        break;
      default:
        this.showActivateServiceDialog = true;
        setTimeout(() => { (this.$refs.activateService as any).takeActionCorrespondingToMessage(res, this.isFreeTrial); }, 200);
        break;
    }
  }
  secondaryserialnumbertransfer(res: any) {
    const options: ConfirmOptions = {
      status: 'high',
      title: this.$t('products.productTransferConfirmation').toString(),
      message: res.msgDesc || '',
      buttons: [
        {
          key: 'save',
          name: 'Ok',
          isDefault: true,
        },
        {
          key: 'cancel',
          name: 'Cancel',
          isDefault: false,
        },
      ],
    };
    confirmService.confirm(options).then((value) => {
      if (value === 'save') {
        this.isoverRide = 'YES';
        this.activateFreeTrial();
      } else {
        this.isoverRide = 'NO';
      }
    });
  }
  showConfirmationDialogForStartTrial(res: any) {
    const options: ConfirmOptions = {
      status: 'major',
      title: this.$t('products.confirmation').toString(),
      message: res?.msgDesc || '',
      buttons: [
        {
          key: 'cancel',
          name: 'Cancel',
          isDefault: false,
        },
        {
          key: 'confirm',
          name: 'Confirm',
          isDefault: true,
        },
      ],
    };
    confirmService.confirm(options).then((value) => {
      if (value === 'confirm') {
        this.activateFreeTrial('', res?.msgCode);
      }
    });
  }
  onRequestExpand(targetExpandedArr: string[], data: ItemExpandRequestData) {
    if (data.expanding && !targetExpandedArr.includes(data.itemId)) {
      targetExpandedArr.push(data.itemId);
    } else if (!data.expanding) {
      const index = targetExpandedArr.indexOf(data.itemId);
      if (index >= 0) {
        targetExpandedArr.splice(index, 1);
      }
    }
  }
  showManageSharedLicense(rootServiceId: string) {
    this.rootServiceId = rootServiceId;
    this.showManageSharedLicenseDialog = true;
  }

  gotoCASB() {
    const request = {
      tenant: this.productDetails.groupid,
      tileName: 'ISMSWSAFEENABLED',
    };
    this.$store
      .dispatch('MswProductsStoreModule/generateCSCCode', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        const { accessCode } = resp.content;
        const url = `${envCongif.spog_url}/muir/spog/login?code=${accessCode}&mode=tileclick&stile=CAS2.0&tenantid=${this.productDetails.groupid}`;
        if (envCongif.leftNavMode === 'APP') {
          window.parent.location.href = url;
        } else {
          window.location.href = url;
        }
      })
      .catch((errorRespose: any) => {
        this.$store.commit('stopLoading');
        console.error(errorRespose);
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }

  addKeysetDialogOnClick(): void {
    const userID = this.$store.getters.getUserId;
    // const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const serialNumber = this.productDetails.serialNumber;
    const request = {
      tenant: userID,
      tileName: 'LICENSEKEYSET',
    };
    this.$store
      .dispatch('MswProductsStoreModule/generateCSCCode', request)
      .then((resp: any) => {
        if (resp?.operationStatus === 'OK' && resp?.content?.accessCode !== '') {
          const redirectURL = `product/licensesKeyset?username=${userID}&strAccessCode=${resp?.content?.accessCode}&serial=${serialNumber}`;
          if (this.licenseList.licenseFile) {
            if (this.licenseList.smaLicense) {
              this.addKeySetDialogToggle();
            } else {
              const request = {
                username: userID,
                serial: serialNumber,
                accessCode: resp?.content?.accessCode || '',
              };
              this.$store
                .dispatch('MswProductsStoreModule/checkKeySet', request)
                .then((resp) => {
                  if (resp && resp.operationStatus === 'NOK') {
                    if (resp && resp.content.bIsGuiDRequired === true) {
                      this.$store.commit('enqueueMessage', {
                        infoType: 'failed',
                        infoMsg: resp.msgDesc,
                      });
                      this.$store.commit('stopLoading');
                    } else {
                      ApiServiceWrapper.replaceTiltPipe(redirectURL);
                      this.$store.commit('stopLoading');
                    }
                  }
                })
                .catch((err) => {
                  ApiServiceWrapper.replaceTiltPipe(redirectURL);
                  console.warn(err);
                  this.$store.commit('stopLoading');
                });
            }
          } else {
            this.$store.dispatch('getLicenseKeySet', redirectURL).then((res: any) => {
              if (res.operationStatus === 'OK') {
                this.$store.commit('stopLoading');
                this.manualLicenses = res.content.LicenseKeyset;
                if (res.content.sha256hash !== undefined && res.content.sha256hash !== null) {
                  this.sha256checksum = res.content.sha256hash;
                }
                this.showAddManualKeysetDialog = true;
              } else {
                this.$store.commit('stopLoading');
                const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
                this.$store.commit('enqueueMessage', message);
              }
            });
          }
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp?.msgDesc || '' };
          this.$store.commit('enqueueMessage', message);
        }
      })
      .catch((errorRespose: any) => {
        this.$store.commit('stopLoading');
        console.error(errorRespose);
      });
  }

  showSysLogAnaltyics(syslogInputs: any) {
    this.sysLogInputs = {};
    this.sysLogInputs = syslogInputs;
    this.sysLogInputs.isFreeTrial = this.isFreeTrial;
    // this.$emit('showSysLog', syslogInputs);
    this.showActivateServiceDialog = false;
    this.showSysLogAnaltyicsDialog = true;
  }
  toggleServiceExpand(service: any) {
    service.expanded = !service.expanded;
    this.$forceUpdate();
  }
  closeSharedLicenseDialog(isRefreshProdList: boolean) {
    if (isRefreshProdList) {
      this.$emit('refreshProdList');
    }
    if (this.$route.query.action) {
      this.$router.push({
        path: `/m/feature/products?serialNumber=${this.serialNumber}&tab=Licenses`,
      });
      window.parent.postMessage(
        {
          redirectUrl: `/m/feature/products?serialNumber=${this.serialNumber}&tab=Licenses`,
        },
        '*',
      );
    }
    this.showManageSharedLicenseDialog = false;
  }
  replaceLocation(endpoint: string, getZipFile: boolean, generateCSCCode: boolean) {
    const userID = this.$store.getters.getUserId;
    const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const serialNumber = this.productDetails.serialNumber;
    let url = '';
    if (generateCSCCode) {
      const request: any = {
        tenant: userID,
        tileName: 'LICENSEKEYSET',
      };
      this.$store
        .dispatch('MswProductsStoreModule/generateCSCCode', request)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp?.operationStatus === 'OK' && resp?.content?.accessCode !== '') {
            if (getZipFile) {
              url = `${endpoint}?username=${userID}&strAccessCode=${resp?.content?.accessCode}&serialNumber=${serialNumber}&strReturnZip=YES`;
            } else {
              url = `${endpoint}?username=${userID}&strAccessCode=${resp?.content?.accessCode}&serialNumber=${serialNumber}`;
            }
            ApiServiceWrapper.replaceTiltPipe(url);
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: resp?.msgDesc || '' };
            this.$store.commit('enqueueMessage', message);
          }
        })
        .catch((errorRespose: any) => {
          this.$store.commit('stopLoading');
          console.error(errorRespose);
        });
    } else {
      if (getZipFile) {
        url = `${endpoint}?username=${userID}&sessionID=${sessionID}&serialNumber=${serialNumber}&strReturnZip=YES`;
      } else {
        url = `${endpoint}?username=${userID}&sessionID=${sessionID}&serialNumber=${serialNumber}`;
      }
      ApiServiceWrapper.replaceTiltPipe(url);
    }
  }
  updateSigManually(sigID: any, getZipFile: boolean) {
    const userID = this.$store.getters.getUserId;
    const request: any = {
      tenant: userID,
      tileName: 'LICENSEKEYSET',
    };
    this.$store
      .dispatch('MswProductsStoreModule/generateCSCCode', request)
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp?.operationStatus === 'OK' && resp?.content?.accessCode !== '') {
          // const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
          const serialNumber = this.productDetails.serialNumber;
          const endpoint = 'downloads/get-Signatures-Downloads';
          let url = '';
          if (getZipFile) {
            url = `${endpoint}?username=${userID}&strAccessCode=${resp?.content?.accessCode}&serialNumber=${serialNumber}&sigID=${sigID}&strReturnZip=YES`;
          } else {
            url = `${endpoint}?username=${userID}&strAccessCode=${resp?.content?.accessCode}&serialNumber=${serialNumber}&sigID=${sigID}`;
          }
          ApiServiceWrapper.replaceTiltPipe(url);
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp?.msgDesc || '' };
          this.$store.commit('enqueueMessage', message);
        }
      })
      .catch((errorRespose: any) => {
        this.$store.commit('stopLoading');
        console.error(errorRespose);
      });
  }
  // changes for license
  handleSearchFilter() {
    this.filterServices();
  }
  selectedServiceChanged() {
    this.filterServices();
    this.checkForPendingExpandStatus();
  }
  filteredList(serviceType: any, serviceMode: string) {
    let services = [];
    if (serviceMode === 'active') {
      services = serviceType.serviceList.filter(
        (service: any) =>
          service.isActive &&
          service.individualDisplay &&
          service.serviceName
            .toLowerCase()
            .indexOf(this.serviceListSearchText.trim().toLowerCase()) > -1,
      );
    }
    if (serviceMode === 'in-active') {
      services = serviceType.serviceList.filter(
        (service: any) =>
          !service.isActive &&
          service.individualDisplay &&
          service.serviceName
            .toLowerCase()
            .indexOf(this.serviceListSearchText.trim().toLowerCase()) > -1,
      );
    }
    if (serviceMode === 'all') {
      services = serviceType.serviceList.filter(
        (service: any) =>
          service.individualDisplay &&
          service.serviceName
            .toLowerCase()
            .indexOf(this.serviceListSearchText.trim().toLowerCase()) > -1,
      );
    }
    return services;
  }
  onInputKey(event: any) {
    console.warn(event);
    if (this.actKey.trim().length === 8 && this.actKey !== '' && !this.readonly) {
      this.showActivateButton = true;
    } else {
      this.showActivateButton = false;
    }
  }
  confirmFreeTrialUpdate() {
    this.messageAccept = 'YES';
    this.activate();
  }
  closeFreeTrialModalUpdate() {
    this.messageAccept = '';
    this.openFreeTrialUpdateModal = false;
  }
  activate(
    rootServiceID: string = this.getRootServiceId(this.serviceList),
    suptradeinserial = '',
  ) {
    this.selectedService.serviceId = rootServiceID;
    const request: any = {
      rootServiceID,
      ...(suptradeinserial && { suptradeinserial }),
      isConfirmFwReboot: this.isConfirmFwReboot,
      username: this.$store.getters.getUserId,
      serialNumber: this.productDetails.serialNumber,
      activationKey: this.actKey,
      messageAccept: this.messageAccept !== '' ? this.messageAccept : '',
      cscDataCenter: '',
      actionType: '',
      isFreeTrial: false,
      autoSendERDomains: '',
      dataCenterLocationID: '',
      adminEmail: '',
      companyName: '',
      casappid: '',
      isoverRide: this.isoverRide || 'NO',
    };
    if (this.acceptedMpssDowngrade) {
      request.acceptedMpssDowngrade = 'YES';
    }
    if (this.showActivateButton) {
      this.isSecaas = this.productDetails.isSecaasFirewallProduct === '1';
      this.$store
        .dispatch('MswProductsStoreModule/activateService', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (
            res.msgCode === 'MSWAPP:ACTSUCCESS' ||
            res.msgCode === 'GEN:SVCACTIVATION_INPROGRESS'
          ) {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: res.msgDesc,
            });
            this.closeFreeTrialModalUpdate();
            this.showMonthlyConvertPopup = res?.content?.showMonthlyConvertPopup || false;
            this.getServiceList();
            this.$emit('needProductsUpdate');
            this.actKey = '';
            if ((this.isoverRide = 'YES')) this.isoverRide = 'NO';
          } else if (res.msgCode === 'MSWAPP:WRONGSIDCHOOSEN') {
            this.activate(res.content.actualserviceID);
          } else if (res.msgCode === 'MSWAPP:SECONDARYSERIALNUMBERONDIFFERENTTENANT') {
            this.secondaryserialnumbertransfer(res);
          } else if (
            res.msgCode === 'MSWAPP:DCREQUIRED' ||
            res.msgCode === 'MSWAPP:NEEDCASBAPP' ||
            res.msgCode === 'MSWAPP:DCREQUIREDFOREMAILENC' ||
            res.msgCode === 'MSWAPP:SYSANALYTICSACTKEY' ||
            res.msgCode === 'MSWAPP:UPGRADERENEWACTIONREQUIRED'
          ) {
            this.showActivateServiceDialog = true;
            setTimeout(() => {
              (this.$refs.activateService as any).setActivationKey(this.actKey);
              (this.$refs.activateService as any).$v!.activationKey!.$touch();
              (this.$refs.activateService as any).takeActionCorrespondingToMessage(res);
            });
          } else if (
            res.operationStatus === 'NOK' &&
            res.msgCode === 'MSWAPP:SWITCHTOCLOUDWARNING'
          ) {
            if (res.content.isShowReboot) {
              confirmService
                .confirm({
                  status: 'major',
                  title: this.$t('products.firewallRebootNotice').toString(),
                  buttons: [
                    {
                      key: 'cancel',
                      name: this.$t('common.cancel').toString(),
                    },
                    {
                      key: 'confirm',
                      name: this.$t('common.confirm').toString(),
                      isDefault: true,
                    },
                  ],
                  message: (h: CreateElement): VNode => { // tslint:disable-line
                    return (
                      <div>
                        <p>
                          <strong>{this.$t('common.important')}</strong>:{' '}
                          {res.content.switchtoCloudWarningText1}
                        </p>
                      </div>
                    ) as VNode;
                  },
                })
                .then((key: any) => {
                  if (key === 'confirm') {
                    this.isConfirmFwReboot = true;
                    this.activate();
                  }
                });
            }
          } else if (
            res.operationStatus === 'NOK' &&
            res.msgCode === 'MSWAPP:MPSSDOWNGRADEWARNING'
          ) {
            if (res.content.showMpssDgWarning) {
              confirmService
                .confirm({
                  status: 'major',
                  title: this.$t('products.removingMPSS').toString(),
                  buttons: [
                    {
                      key: 'cancel',
                      name: this.$t('common.cancel').toString(),
                    },
                    {
                      key: 'confirm',
                      name: this.$t('common.confirm').toString(),
                      isDefault: true,
                    },
                  ],
                  message: (h: CreateElement): VNode => { // tslint:disable-line
                    return (
                      <div>
                        <p>{res.content.mpssDownGradeWarningMsg}</p>
                      </div>
                    ) as VNode;
                  },
                })
                .then((key: any) => {
                  if (key === 'confirm') {
                    this.acceptedMpssDowngrade = true;
                    this.isConfirmFwReboot = true;
                    this.activate();
                  }
                });
            }
          } else if (
            res.operationStatus === 'NOK' &&
            res.msgCode === 'MSWAPP:UPGRADECONFIRMATIONREQUIRED'
          ) {
            this.freetrialUpgradeConfirmation = res.content.arrUpgradeConfirmation[0];
            this.openFreeTrialUpdateModal = true;
          } else if (res?.msgCode === 'MSWAPP:TRADEINREQUIRED') {
            this.showSecureUpdateModal = true;
            this.activateServiceData['content'] = res?.content || {};
            this.activateServiceData['content'].arrTradeInSerials =
              res?.arrTradeInSerials || [];
          } else {
            if ('GEN:INVALIDACTKEY') {
              this.messageAccept = '';
              if (res.content.confirmMessage && res.content.confirmMessage === 'YES') {
                this.messageAccept = 'YES';
                this.$store.commit('enqueueMessage', {
                  infoType: 'major',
                  infoMsg: res.msgDesc,
                });
              } else {
                this.$store.commit('enqueueMessage', {
                  infoType: 'failed',
                  infoMsg: res.msgDesc,
                });
              }
            } else {
              this.$store.commit('enqueueMessage', {
                infoType: 'failed',
                infoMsg: res.msgDesc,
              });
            }
          }
        })
        .finally(() => {
          this.isConfirmFwReboot = false;
          this.acceptedMpssDowngrade = false;
        });
    }
  }
  getRootServiceId(serviceList: any) {
    const activeServicesList: any[] = [];
    serviceList.forEach((serviceType: any) => {
      const services = serviceType.serviceList.filter(
        (service: any) => service.individualDisplay,
      );
      if (services.length > 0) {
        activeServicesList.push({
          serviceTypeName: serviceType.serviceTypeName,
          serviceList: services,
        });
      }
    });
    if (activeServicesList.length === 0) return '';
    return activeServicesList[0]?.serviceList[0]?.serviceId || '';
  }
  get getMessageAccept() {
    return this.messageAccept;
  }
  closeActivationDialog(value: boolean) {
    // SMA100 to CSE Promotion
    const { activateServiceData } = (this.$refs.activateService as any) || {};
    this.isSecaas = this.productDetails.isSecaasFirewallProduct === '1';
    if (Object.keys(activateServiceData)?.length > 0) {
      this.isTradeInRequiredForServiceActivation = true;
      this.activateServiceData = activateServiceData;
      this.showSecureUpdateModal = true;
      this.showActivateServiceDialog = false;
      return;
    }

    if (this.actKey !== '') {
      this.actKey = '';
    }
    if (this.messageAccept !== '') {
      this.messageAccept = '';
    }
    if (this.isoverRide && this.isoverRide === 'YES') {
      this.isoverRide = 'NO';
    }
    if (value) {
      this.getServiceList();
      this.$emit('needProductsUpdate');
    }
    this.showActivateServiceDialog = false;
  }
  toggleAll() {
    this.expand = !this.expand;
    this.expandedServiceList.map((serviceType: any) => {
      serviceType.expanded = this.expand;
      return serviceType.serviceList.map((service: any) => {
        if (service.secondaryServiceList && service.secondaryServiceList.length > 0) {
          service.expanded = this.expand;
        }
      });
    });
    this.filterServices();
  }
  serviceTypeToggle(serType: any) {
    serType.expanded = !serType.expanded;
    this.$forceUpdate();
    this.checkForPendingExpandStatus();
  }
  checkForPendingExpandStatus() {
    const listPending = this.filteredServiceList.filter((serviceType: any) => {
      return serviceType.expanded === true;
    });
    if (listPending && listPending.length > 0) {
      this.expand = true;
    } else {
      this.expand = false;
    }
  }
  getLisenceInfo(serviceType: any) {
    const services = serviceType.serviceList.filter(
      (service: any) => service.isActive && service.individualDisplay,
    );
    return services && services.length ? services.length : 0;
  }
  convertToTitleCase(value: string) {
    let values: string = '';
    const val: any = value
      .toString()
      .toLowerCase()
      .split(' ');
    if (value) {
      val.forEach((element: any) => {
        values = `${values}  ${element.charAt(0).toUpperCase()}${element.slice(1)}`;
      });
      return values.trim();
    }
    return '';
  }
  getServiceList() {
    this.columnWidthConfigModified = {};
    this.reinitializeColumnWidthConfig();
    this.columnWidthConfigModified = { ...this.columnWidthConfigInitial };
    this.loadingText = 'Licenses are loading...';
    this.$store
      .dispatch('MswProductsStoreModule/getServiceInfo', this.serialNumber)
      .then((res: any) => {
        this.serviceList = [];
        this.isSignatureAvailable = false;
        this.licenseList = {};
        this.loadingText = '';
        if (res.operationStatus === 'OK') {
          this.sigIDList = res.sigIDList;
          this.licenseList = {
            smaLicense: res.isSMALicenseneed,
            licenseFile: res.isLicenseFile,
          };
          this.isSignatureAvailable = res.isSignatureAvaiable;
          if (res.saseWarningText && res.saseWarningText !== '') {
            this.$store.commit('MswProductsStoreModule/setZtnaMsg', res.saseWarningText);
          }
          let col1: boolean = false;
          let col2: boolean = false;
          let col3: boolean = false;
          const col4: { value: boolean; nodeCountLength: number; maxCountLength: number } = {
            value: false,
            nodeCountLength: 0,
            maxCountLength: 0,
          };
          let col5: boolean = false;
          res.serviceTypeList.map((serviceType: any) => {
            serviceType.serviceList.forEach((service: any) => {
              if (service !== null && service.hasOwnProperty('individualDisplay')) {
                if (
                  service.serviceName === 'SSL VPN' ||
                  (service.bShowNote &&
                    service.releaseStatus !== 'EOL' &&
                    service.primaryserialnumber === '' &&
                    service.individualDisplay === true)
                ) {
                  col1 = true;
                }
              }
              if (service !== null && service.hasOwnProperty('individualDisplay')) {
                if (
                  this.productDetails.provisionStatus !== '' &&
                  this.productDetails.provisionStatus !== undefined &&
                  this.productDetails.pID === '402' &&
                  service.serviceName === 'Cloud Application Security' &&
                  service.releaseStatus !== 'EOL' &&
                  service.primaryserialnumber === '' &&
                  service.individualDisplay === true
                ) {
                  col2 = true;
                }
              }
              if (service !== null && service.hasOwnProperty('individualDisplay')) {
                if (
                  service.isLSG === true &&
                  service.releaseStatus !== 'EOL' &&
                  service.primaryserialnumber === '' &&
                  service.individualDisplay === true
                ) {
                  col3 = true;
                }
              }
              if (service !== null && service.hasOwnProperty('individualDisplay')) {
                if (
                  service.nodecount.toString() !== '' &&
                  service.maxtech.toString() !== '' &&
                  service.individualDisplay === true
                ) {
                  col4.value = true;
                  if (service.nodecount.toString().length > col4.nodeCountLength) {
                    col4.nodeCountLength = service.nodecount.toString().length;
                  }
                  if (service.maxtech.toString().length > col4.maxCountLength) {
                    col4.maxCountLength = service.maxtech.toString().length;
                  }
                }
                if (
                  service.nodecount.toString() !== '' &&
                  service.maxtech.toString() === '' &&
                  service.individualDisplay === true
                ) {
                  col4.value = true;
                  if (service.nodecount.toString().length > col4.nodeCountLength) {
                    col4.nodeCountLength = service.nodecount.toString().length;
                  }
                }
                if (
                  service.nodecount.toString() === '' &&
                  service.maxtech.toString() !== '' &&
                  service.individualDisplay === true
                ) {
                  col4.value = true;
                  if (service.maxtech.toString().length > col4.maxCountLength) {
                    col4.maxCountLength = service.maxtech.toString().length;
                  }
                }
              }
              if (service !== null && service.hasOwnProperty('individualDisplay')) {
                if (
                  service.isSoonExpiring === 'YES' &&
                  service.expirydate !== '' &&
                  service.individualDisplay === true
                ) {
                  col5 = true;
                }
              }
            });
          });
          if (col1) {
            // tslint:disable-next-line:max-line-length
            this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH =
              this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH +
              this.columnWidthConfigInitial.column4.width;
          }
          if (col2) {
            // tslint:disable-next-line:max-line-length
            this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH =
              this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH +
              this.columnWidthConfigInitial.column5.width;
          }
          if (col3) {
            // tslint:disable-next-line:max-line-length
            this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH =
              this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH +
              this.columnWidthConfigInitial.column6.width;
          }
          // tslint:disable-next-line:max-line-length
          this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH =
            this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH +
            this.columnWidthConfigInitial.COLUMN_PADDING_WIDTH;
          if (col4.value) {
            let colValue = this.columnWidthConfigInitial.column2.width;
            let nodeCountWidth: number = 0;
            let maxCountWidth: number = 0;
            if (col4.nodeCountLength !== 0) {
              nodeCountWidth =
                col4.nodeCountLength *
                this.columnWidthConfigInitial.COUNT_COLUMN_SINGLE_CHARACTER_WIDTH;
            }
            if (col4.maxCountLength !== 0) {
              // tslint:disable-next-line:max-line-length
              maxCountWidth =
                col4.maxCountLength *
                  this.columnWidthConfigInitial.COUNT_COLUMN_SINGLE_CHARACTER_WIDTH +
                this.columnWidthConfigInitial.MAXCOUNT_TEXT_WIDTH;
            }
            colValue =
              nodeCountWidth +
              maxCountWidth +
              2 * this.columnWidthConfigInitial.COLUMN_PADDING_WIDTH;
            if (colValue < this.columnWidthConfigInitial.column2.width) {
              colValue = this.columnWidthConfigInitial.column2.width;
            }
            this.columnWidthConfigModified.column2.width = colValue;
          }
          if (col5) {
            // tslint:disable-next-line:max-line-length
            this.columnWidthConfigModified.column3.width =
              this.columnWidthConfigModified.column3.width +
              this.columnWidthConfigInitial.EXPIRING_SOON_ALERT_WIDTH;
          }
          // tslint:disable-next-line:max-line-length
          this.columnWidthConfigModified.EXPIRATION_DETAIL_TOTALWIDTH =
            this.columnWidthConfigModified.column1.width +
            this.columnWidthConfigModified.column2.width +
            this.columnWidthConfigModified.column3.width;
          // tslint:disable-next-line:max-line-length
          this.columnWidthConfigModified.column1.widthPercentage = this.getPercentage(
            this.columnWidthConfigModified.EXPIRATION_DETAIL_TOTALWIDTH,
            this.columnWidthConfigModified.column1.width,
          );
          // tslint:disable-next-line:max-line-length
          this.columnWidthConfigModified.column2.widthPercentage = this.getPercentage(
            this.columnWidthConfigModified.EXPIRATION_DETAIL_TOTALWIDTH,
            this.columnWidthConfigModified.column2.width,
          );
          // tslint:disable-next-line:max-line-length
          this.columnWidthConfigModified.column3.widthPercentage = this.getPercentage(
            this.columnWidthConfigModified.EXPIRATION_DETAIL_TOTALWIDTH,
            this.columnWidthConfigModified.column3.width,
          );
          // tslint:disable-next-line:max-line-length
          this.columnWidthConfigModified.TOTAL_COL_WIDTH_EXCEPT_SERVICENAME =
            this.columnWidthConfigModified.ACTION_COLUMN_TOTALWIDTH +
            this.columnWidthConfigModified.EXPIRATION_DETAIL_TOTALWIDTH; // 295.82 check
          res.serviceTypeList.map((serviceType: any) => {
            const allServices = serviceType.serviceList.filter((service: any) => {
              if (service !== null && service !== undefined) {
                return service.individualDisplay;
              }
            });
            if (allServices.length > 0) {
              this.serviceList.push({
                serviceTypeName: serviceType.serviceTypeName,
                serviceList: allServices,
                expanded: true,
              });
            }
          });
          this.$store.commit('stopLoading');
        } else {
          this.loadingText = 'You have no Licenses.';
          this.$store.commit('stopLoading');
        }
        setTimeout(() => { this.focusActivationField(); this.setHeaderConfig(); }, 0);
      });
  }
  submitSysLogAnalystics(obj: any) {
    if (obj) {
      const request = {
        rootServiceID: 6950,
        username: this.$store.getters.getUserId,
        serialNumber: this.productDetails.serialNumber,
        activationKey: this.sysLogInputs.activationKey,
        messageAccept: '',
        cscDataCenter: '',
        actionType: '',
        isFreeTrial: this.sysLogInputs.isFreeTrial,
        autoSendERDomains: '',
        dataCenterLocationID: '',
        adminEmail: '',
        companyName: '',
        casappid: '',
        replacementyype: obj.tenantType,
        tenantSerial: obj.tenantSerial,
      };
      this.$store
        .dispatch('MswProductsStoreModule/activateService', request)
        .then((res: any) => {
          this.$store.commit('stopLoading');
          if (res.msgCode === 'MSWAPP:ACTSUCCESS') {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: res.msgDesc,
            });
            this.getServiceList();
            this.$emit('needProductsUpdate');
            this.showSysLogAnaltyicsDialog = false;
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res.msgDesc });
            this.showSysLogAnaltyicsDialog = false;
          }
        });
    } else {
      this.showSysLogAnaltyicsDialog = false;
    }
  }
  manageScroll() {
    if (this.$refs.scroller) {
      if (
        (this.$refs.scroller as SwScrollView).scrollTop > 0 &&
        this.expand &&
        (this.$refs.scroller as SwScrollView).scrollTop
      ) {
        (this.$refs.scroller as SwScrollView).updatePosition(0, true);
      }
    }
  }
  focusActivationField() {
    if (this.$refs.refActKeyInput as SwTextfield) {
      (this.$refs.refActKeyInput as SwTextfield).focus();
    }
  }
  setHeaderConfig() {
    this.headerConfig.header2.width = 0;
    this.headerConfig.header3.width = 0;
    this.headerConfig.header4.width = 0;
    this.headerConfig.header5.width = 0;
    this.headerConfig.header6.width = 0;
    this.totalfifthColWidth = 0;
    this.headerConfig.header2.width = (this.$refs.serviceName as any)
      ? (this.$refs.serviceName as any)[0].clientWidth
      : 0;
    this.headerConfig.header3.width = (this.$refs.serviceStatus as any)
      ? (this.$refs.serviceStatus as any)[0].clientWidth
      : 0;
    this.headerConfig.header4.width = (this.$refs.count as any)
      ? (this.$refs.count as any)[0].clientWidth
      : 0;
    this.headerConfig.header5.width = (this.$refs.expiryDate as any)
      ? (this.$refs.expiryDate as any)[0].clientWidth
      : 0;
    this.headerConfig.header6.width = (this.$refs.actions as any)
      ? (this.$refs.actions as any)[0].clientWidth + 20
      : 0;
    // tslint:disable-next-line:max-line-length
    this.totalfifthColWidth =
      this.headerConfig.header2.width +
      this.headerConfig.header3.width +
      this.headerConfig.header4.width +
      this.headerConfig.header5.width;
  }
  getPercentage(totalColWidth: number, colWidth: number) {
    return (colWidth / totalColWidth) * 100;
  }
  getProcessedRolloverText(svc: any) {
    if (!svc || typeof svc.rollovertext !== 'string') {
      return '';
    }
    const isSonicOsExpanded =
    typeof svc.serviceName === 'string' &&
    svc.serviceName.trim() === 'SonicOS Expanded';
    if (!isSonicOsExpanded) {
      return svc.rollovertext;
    }
    const text = svc.rollovertext;
    const result = text.replaceAll('<br/>', '');
    return result;
  }
  hoverPopoverValue(sigID: any) {
    // tslint:disable-next-line:no-unused
    const viewMSWAppsRender = (h: CreateElement, data: any): VNode => {
      return (
        <div>
          <div>{ data.warningText }</div>
          <div>
            <ol style="list-style-type: none;">
              <li>i. { data.gavDate }</li>
              <li>ii. { data.idpDate }</li>
              <li>iii. { data.antiSpywareDate }</li>
            </ol>
          </div>
        </div>
      ) as VNode;
    };
    return {
      withCloseIcon: false,
      trigger: 'hover',
      content: (h: CreateElement) => viewMSWAppsRender(h, sigID),
    };
  }

  reinitializeColumnWidthConfig() {
    this.columnWidthConfigInitial = {
      column0: {
        name: 'serviceName',
        width: 0,
        widthPercentage: 0,
        type: 'service name',
        default: true,
      },
      column1: {
        name: 'status',
        width: 88.1,
        widthPercentage: 34.8,
        type: 'expiry',
        default: true,
      },
      column2: {
        name: 'count',
        width: 60,
        widthPercentage: 23.7,
        type: 'expiry',
        default: true,
      },
      column3: {
        name: 'expiry date',
        width: 105,
        widthPercentage: 41.48,
        type: 'expiry',
        default: true,
      },
      column4: {
        name: 'info icon',
        width: 50,
        type: 'actions',
        default: false,
      },
      column5: {
        name: 'csc icon',
        width: 27,
        type: 'actions',
        default: false,
      },
      column6: {
        name: 'sharing icon',
        width: 70,
        type: 'actions',
        default: false,
      },
      column7: {
        name: 'activate',
        width: 75,
        type: 'actions',
        default: true,
      },
      column8: {
        name: 'buy',
        width: 50,
        type: 'actions',
        default: true,
      },
      column9: {
        name: 'free trail',
        width: 80,
        type: 'actions',
        default: true,
      },
      EXPIRATION_DETAIL_TOTALWIDTH: 253.1,
      ACTION_COLUMN_TOTALWIDTH: 205,
      COUNT_COLUMN_SINGLE_CHARACTER_WIDTH: 10,
      COLUMN_PADDING_WIDTH: 10,
      MAXCOUNT_TEXT_WIDTH: 40,
      EXPIRING_SOON_ALERT_WIDTH: 15,
      TOTAL_COL_WIDTH_EXCEPT_SERVICENAME: 0,
    };
  }
  downloadSignature() {
    this.replaceLocation('downloads/get-Signatures-Downloads', false, true);
  }
  downloadFirmwareOrSignature(firmwareOrSignature: string) {
    const username = this.$store.getters.getUserId;
    const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    const serialNumber = this.productDetails.serialNumber;
    if (firmwareOrSignature === 'firmware') {
      this.$store
        .dispatch('MswProductsStoreModule/requestToDownloadClosedNetworkFirmware', {
          username,
          sessionID,
          serialNumber,
        })
        .then((response) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: response.msgDesc,
            });
          } else {
            this.$store.commit('enqueueMessage', {
              infoType: 'failed',
              infoMsg: response.msgDesc,
            });
          }
        });
    } else {
      this.$store
        .dispatch('MswProductsStoreModule/requestToDownloadClosedNetworkSignature', {
          username,
          sessionID,
          serialNumber,
        })
        .then((response) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', {
              infoType: 'success',
              infoMsg: response.msgDesc,
            });
          } else {
            this.$store.commit('enqueueMessage', {
              infoType: 'failed',
              infoMsg: response.msgDesc,
            });
          }
        });
    }
  }
}
